import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

@HookClass('request')
export class RequestHook extends BaseHook {

    @Hook('ec378832-63b2-4363-873d-a10f961884c4')
    public getHeaders(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = this.context.request?.headers[inputArtifact.object.data];
        return of(outputArtifact);
    }

    @Hook('c50476fd-5e0d-4c1c-9acc-e023d0775207')
    public origin(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;

        if (this.context.request.headers['origin'] == null || this.context.request.headers['origin'] == 'null')
            outputArtifact.object = new URL(`https://${this.context.request.headers['host']}`);
        else
            outputArtifact.object = new URL(this.context.request.headers['origin']);
        return of(outputArtifact);
    }

    @Hook('6908be1c-caf6-4064-9c7d-192792a9a12b')
    public getAuthorizationToken(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = this.context.literalToken;
        return of(outputArtifact);
    }

    @Hook('4a0e7a59-e8ef-44be-bb9c-3ea5fb6f7b38')
    public userAgent(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = this.context.request?.headers['user-agent'];
        return of(outputArtifact);
    }

    @Hook('655a6325-a41d-44b1-baa7-8eb8ff82e5cb')
    public remoteAddress(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = this.context.request.connection.remoteAddress;
        return of(outputArtifact);

    }

    @Hook('bd4ccea7-f752-497d-8edf-f6df5ca2c6ff')
    public redirect(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = 12;
        const params = inputArtifact.object.params ? new URLSearchParams(inputArtifact.object.params) : null;

        const format$ = (value: any, key: any) => {
            if (typeof value == 'string') {
                return value.replace(new RegExp(`\{\{${key}\}\}`, 'g'), inputArtifact.object.data[key]);
            } else if (value instanceof Array)
                value.forEach((templateItem: any) => templateItem = format$(templateItem, key));
            else if (value instanceof Object)
                Object.keys(value).forEach((property: any) => value[property] = format$(value[property], key));

            return value;
        };

        let url: any;
        if (inputArtifact.object.url) {
            if (inputArtifact.object.data)
                Object.keys(inputArtifact.object.data).forEach((key: string) => {
                    inputArtifact.object.url = format$(inputArtifact.object.url, key);
                });

            url = new URL(`${inputArtifact.object.url}${params ? '?' + params.toString() : ''}`);
        } else if (inputArtifact.object.path) {
            if (inputArtifact.object.data)
                Object.keys(inputArtifact.object.data).forEach((key: string) => {
                    inputArtifact.object.path = format$(inputArtifact.object.path, key);
                });

            url = new URL(`${this.context.request.headers['origin']}${inputArtifact.object.path}`);
        }

        outputArtifact.object = {
            kind: 12,
            url: url.toString()
        };

        if (inputArtifact.object.redirect)
            this.context.response.redirect(inputArtifact.object.status ? inputArtifact.object.status : 302, url.toString());

        return of(outputArtifact);
    }
}
